import { IQueueDepthBucket } from 'components/Chart/QueueDepthChart/QueueDepthChart'

const BUCKET_VALUES = [
  18, 16, 14, 12, 10, 8, 5, 4, 6, 8, 10, 12,
  14, 18, 22, 26, 30, 33, 31, 28, 24, 20, 16, 14,
]

const BUCKET_LABELS: Record<number, string> = {
  0: '18:00',
  4: '22:00',
  8: '02:00',
  12: '06:00',
  16: '10:00',
  20: '14:00',
}

export const QUEUE_DEPTH_BUCKETS: IQueueDepthBucket[] = BUCKET_VALUES.map((value, index) => ({
  value,
  label: BUCKET_LABELS[index],
}))

export const QUEUE_DEPTH_PEAK = Math.max(...BUCKET_VALUES)

export interface IBacklogContributorRow {
  id: number
  name: string
  backlogShare: string
  depth: number
  medianMin: number
}

export const BACKLOG_CONTRIBUTORS: IBacklogContributorRow[] = [
  { id: 1, name: 'Tailings Dam 3 Construction', backlogShare: '33.3% of backlog', depth: 26, medianMin: 28 },
  { id: 2, name: 'Q1 Mill Throughput Push', backlogShare: '23.1% of backlog', depth: 18, medianMin: 32 },
  { id: 3, name: 'Q2 North Pit Pre-strip', backlogShare: '21.8% of backlog', depth: 17, medianMin: 23 },
  { id: 4, name: 'Haul Road Maintenance Cycle Q2', backlogShare: '21.8% of backlog', depth: 17, medianMin: 33 },
]
